module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-114x114-eb687baf6fc77321238cb973911f7987.png";